export function hex2rgba(color) {
  var h1 = parseInt(color.substring(0, 2), 16);
  var h2 = parseInt(color.substring(2, 4), 16);
  var h3 = parseInt(color.substring(4, 6), 16);
  if (color.length === 6) {
    return "rgb(".concat(h1, ", ").concat(h2, ", ").concat(h3, ")");
  } else {
    var h4 = parseInt(color.substring(6, 8), 16);
    return "rgba(".concat(h1, ", ").concat(h2, ", ").concat(h3, ", ").concat(h4 / 255, ")");
  }
}
export function isColor(color) {
  return typeof color === "string" && (color.length === 6 || color.length === 8 || color.startsWith("#") && (color.length === 7 || color.length === 9));
}
export function color2rgba(color) {
  if (!isColor(color)) {
    return undefined;
  }
  if (color !== null && color !== void 0 && color.startsWith("#")) {
    return hex2rgba(color.substring(1));
  } else {
    // return hex2rgba(color);
    return color;
  }
}